export const roles = {
  SuperAdmin: "SUPER_ADMIN",
  Admin: "ADMIN",
  Tutor: "TUTOR",
  Learner: "LEARNER"
};
